module.exports = __webpack_public_path__ + "static/chantalayoga-0c49cb3fd0603300843a4b5f15d09786.jpg";